module.exports = __webpack_public_path__ + "img/hand-icon.7d2a7aa2.png";